import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import {
  Box,
  Button,
  Link,
  Stack,
  Typography,
} from '@mui/material';

export const LEGAL_BUSINESS = Object.freeze({
  registeredName: 'Luke Rutley Ltd',
  tradingName: 'Struxor',
  companyNumber: '16256150',
  placeOfRegistration: 'England and Wales',
  registeredOffice: '12 Higher Dean, Buckfastleigh, England, TQ11 0LX',
  contactEmail: 'luke@struxorapp.com',
});

export const AI_RAMS_DISCLAIMER =
  'AI-generated RAMS are draft documents only. They must be reviewed, amended where necessary, and approved by a competent human before issue or use on site. Responsibility for the final document, legal compliance, and site safety remains with you.';

export default function LegalBusinessDetails({
  compact = false,
  textAlign = 'left',
  textColor = 'text.secondary',
  linkColor = 'primary.main',
  showLegalLinks = false,
  sx,
}) {
  const variant = compact ? 'caption' : 'body2';
  const alignItems = textAlign === 'center' ? 'center' : 'flex-start';

  return (
    <Stack spacing={compact ? 0.5 : 1} alignItems={alignItems} sx={sx}>
      <Typography variant={variant} sx={{ color: textColor, lineHeight: 1.7, textAlign }}>
        <Box component="span" sx={{ fontWeight: 700 }}>
          {LEGAL_BUSINESS.tradingName}
        </Box>{' '}
        is operated by{' '}
        <Box component="span" sx={{ fontWeight: 700 }}>
          {LEGAL_BUSINESS.registeredName}
        </Box>{' '}
        (Company No. {LEGAL_BUSINESS.companyNumber}), registered in {LEGAL_BUSINESS.placeOfRegistration}.
      </Typography>

      <Typography variant={variant} sx={{ color: textColor, lineHeight: 1.7, textAlign }}>
        Registered office: {LEGAL_BUSINESS.registeredOffice}.
      </Typography>

      <Typography variant={variant} sx={{ color: textColor, lineHeight: 1.7, textAlign }}>
        Contact:{' '}
        <Link href={`mailto:${LEGAL_BUSINESS.contactEmail}`} underline="hover" sx={{ color: linkColor, fontWeight: 600 }}>
          {LEGAL_BUSINESS.contactEmail}
        </Link>{' '}
        or write to the registered office.
      </Typography>

      {showLegalLinks ? (
        <Stack direction="row" spacing={1} flexWrap="wrap" justifyContent={textAlign === 'center' ? 'center' : 'flex-start'}>
          <Button
            size="small"
            color="inherit"
            component={RouterLink}
            to="/terms"
            sx={{ minWidth: 'auto', px: 0, textTransform: 'none', color: linkColor, fontWeight: 600 }}
          >
            Terms
          </Button>
          <Button
            size="small"
            color="inherit"
            component={RouterLink}
            to="/privacy"
            sx={{ minWidth: 'auto', px: 0, textTransform: 'none', color: linkColor, fontWeight: 600 }}
          >
            Privacy
          </Button>
        </Stack>
      ) : null}
    </Stack>
  );
}
